<template>
  <Modal
    :open="show"
    @closed="$emit('close')"
  >
    <div class="modal-header border-0">
      <h5 class="modal-title m-0 d-flex align-items-center">
        Reassign Approval
      </h5>
      <button @click="$emit('close')" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label for="select_user" class="form-label">Select User <span class="text-danger">*</span></label>
          <select
            id="select_user"
            class="form-select"
            v-model="selectedUser"
            :disabled="loading || users.length === 0"
            required>
            <option value="" disabled>Select a user</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user.first_name }} {{ user.last_name }}
            </option>
          </select>
        </div>
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-outline-secondary me-2"
            @click="$emit('close')"
            :disabled="loading"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading || !selectedUser"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Reassign
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import { ref, onMounted } from 'vue';
import userService from '@/api/userService';

export default {
  name: 'ReassignLeaveRequestModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'reassign'],
  setup(props, { emit }) {
    const users = ref([]);
    const selectedUser = ref('');

    const fetchUsers = async () => {
      try {
        const data = await userService.getUsers();
        users.value = data || [];
      } catch (e) {
        console.error(e);
      }
    };

    const handleSubmit = () => {
      if (!selectedUser.value) return;
      emit('reassign', selectedUser.value);
      selectedUser.value = '';
    };

    onMounted(() => {
      fetchUsers();
    });

    return {
      users,
      selectedUser,
      handleSubmit,
    };
  },
};
</script>
